// @TODO: Change once this is moved to state.fields[current field id]
export const currentFieldSelector = (state) => state.field;

export const currentOperationsSelector = (state) => {
  const { current } = state.operations;
  const operations = Array.isArray(current) ?
    current.map(operation => operation.operationId) :
    [current];
  return operations;
}

/**
 * @param {Object} state
 * @return {Array} An array containing the fields as objects ordered alphabetically.
 */
export const accessibleFieldsSelector = (state) => {
  const { byId: byIdOperations, current } = state.operations;
  const { allIds, byId: byIdFields } = state.fields;
  // this is support single operation Users and Proxying support accounts
  let fields = [];
  if (typeof current === 'string' || current === null) {
    const operationSelected =
      current && byIdOperations[current];
    if (current) {
      fields = allIds.filter((fieldId) => operationSelected && operationSelected.fields.includes(fieldId));
    } else {
      fields = allIds;
    }
    return fields.map((field) => byIdFields[field]);
  }

  let multiOperations = [];

  if (current[0] === 'all-operations') {
    multiOperations = Object.values(byIdOperations);
  } else {
    multiOperations = current.map((operationId) => byIdOperations[operationId]);
  }

  const multiOperationsFields = multiOperations.reduce((multiFields, operation) => [...multiFields, ...operation.fields], []);
  fields = allIds.filter((fieldId) => multiOperationsFields.includes(fieldId));
  return fields.map((field) => byIdFields[field]);
};
